module.exports = __webpack_public_path__ + "img/12_75.fb56762d.png";